/** @file contentMethods: built-in templates, sector tables and the guides served at the point of use. */
import type { CommandListReply } from '../types/commandCatalog';
import type { GuideListReply, TableInfoReply, TemplateListReply, TemplateSummaryWire } from '../types/restAdded';
import type { ClientOptions } from './clientOptions';
import { fillPath } from './fillPath';
import { request } from './request';

/** The content members of the client. */
export type ContentMethods = {
  /** `GET /api/v1/templates`. */
  templates: () => Promise<TemplateSummaryWire[]>;
  /** `GET /api/v1/guides`: the guide topics. */
  guides: () => Promise<string[]>;
  /** `GET /api/v1/guides/{topic}`: the guide as markdown. */
  guide: (topic: string) => Promise<string>;
  /** `GET /api/v1/commands`: every command with a summary, its input shape and an example. */
  commandCatalog: () => Promise<CommandListReply>;
  /** `GET /api/v1/tables/{id}`: a built-in sector table read out (azimuth ranges, flip pairs, drawn-azimuth defaults). */
  tableInfo: (id: string) => Promise<TableInfoReply>;
};

/** Content calls over `opts`. */
export function contentMethods(opts: ClientOptions): ContentMethods {
  return {
    templates: async () => (await request<TemplateListReply>(opts, { method: 'GET', path: '/api/v1/templates', accept: 'json' })).value.templates,
    guides: async () => (await request<GuideListReply>(opts, { method: 'GET', path: '/api/v1/guides', accept: 'json' })).value.topics,
    commandCatalog: async () => (await request<CommandListReply>(opts, { method: 'GET', path: '/api/v1/commands', accept: 'json' })).value,
    tableInfo: async (id) => (await request<TableInfoReply>(opts, { method: 'GET', path: fillPath('/api/v1/tables/{id}', { id }), accept: 'json' })).value,
    guide: async (topic) => (await request<string>(opts, { method: 'GET', path: fillPath('/api/v1/guides/{topic}', { topic }), accept: 'text' })).value,
  };
}
